import React from "react";
import UserAvatar from "../UserAvatar";
import { formatYmdHi } from "../../utils/formatDateTime";

export default function BlogCommentItem({ comment }) {
    const name = comment.user || "Пользователь";
    const added = formatYmdHi(comment.createdAt);

    return (
        <article className="comment-item">
            <UserAvatar avatarUrl={comment.userAvatarUrl} name={name} className="comment-item__avatar" size={52} />
            <div>
                <div className="comment-item__head">
                    <div className="comment-item__name-row">
                        <strong>{name}</strong>
                    </div>
                    {added && <time className="comment-item__date">{added}</time>}
                </div>
                <p style={{ margin: "8px 0 0", whiteSpace: "pre-wrap" }}>{comment.comment || comment.text}</p>
            </div>
        </article>
    );
}
